import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
	return (
		<section id="smt">
			<div className="s_container hd bg1 s_d-flex s_jcontent-center s_aitems-center text-center">
				<div>
					<div className="hd-hol center-text">
						<h1 className="sf">Student Registration Form</h1>
					</div>
					<Link
						to="/register"
						className="smt-btn show-smt-form-btn"
						type="button"
					>
						Click To Register
					</Link>
				</div>
			</div>

			<div className="s_container inro s_d-flex s_jcontent-center s_aitems-center">
				<div className="inro-hol center-text">
					<img src="assets/img/logo.png" alt="SmarTribe" />
					<h2 className="smt-hd">
						Welcome To Smar<span>Tribe</span> Registrat<span>ion</span>
					</h2>
					<p>
						Enroll your kids on the online class to sharpen their brains. Lets
						train your kids to code, it will develop their brains. Let us use
						Abacus to improve your kids&apos; concentration, logical thinking,
						comprehension, listening skills and reasoning skills.
					</p>
					<Link
						to="/register"
						className="smt-btn bg1 white-text show-smt-form-btn"
						type="button"
					>
						REGISTER NOW
					</Link>
				</div>
			</div>

			<div className="s_container vid s_min-height-max s_d-flex s_jcontent-center s_aitems-center">
				<div className="vid-hol center-text">
					<div className="grid">
						<div className="s12 m6 pad">
							<div className="video-div">
								<div>
									<iframe
										src="https://www.youtube-nocookie.com/embed/zZjeazCYH9w"
										frameBorder="0"
										allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
										allowFullScreen
									></iframe>
								</div>
								<h5>English Video</h5>
							</div>
						</div>
						<div className="s12 m6 pad">
							<div className="video-div">
								<div>
									<iframe
										src="https://www.youtube-nocookie.com/embed/QqVFTmT-aCA"
										frameBorder="0"
										allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
										allowFullScreen
									></iframe>
								</div>
								<h5>Twi Video</h5>
							</div>
						</div>
						<div className="s12 pad">
							<Link
								to="/register"
								className="smt-btn bg1 white-text show-smt-form-btn"
								type="button"
							>
								REGISTER NOW
							</Link>
						</div>
					</div>
				</div>
			</div>

			<footer>
				<span>
					<a href="tel:0205003933">
						<i className="fas fa-phone"></i> 0205003933
					</a>
				</span>
				<span>
					<a href="tel:0558740741">
						<i className="fas fa-phone"></i> 0558740741
					</a>
				</span>
			</footer>
		</section>
	);
};

export default Home;
